
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/feedback/public",
      function () {
        return require("private-next-pages/feedback/public.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/feedback/public"])
      });
    }
  